import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0040',
    ecrans: ['00-2'],
    params: [
        'regcleint',
        '?prucleint',
        '?prbcleint',
        '?prvcleint'
    ]
});
